export default [
	//单位列表
	{
		path: 'unit',
		name: 'm_unit',
		props: route => route.params,
		component: () => import('@/pages/basic/dic_unit_list')
	},
	//字典列表
	{
		path: 'dic',
		name: 'm_operation_dic',
		props: route => route.params,
		component: () => import('@/pages/basic/operation_dic_list')
	}, {  // 自定义编号规则
		path: 'numberRule',
		name: 'm_custom_seqnumber',
		props: route => route.params,
		component: () => import('@/pages/custom/number_rule')
	},
	//派单规则列表
	{
		path: 'dispatch_rule',
		name: 'm_dispatch_rule',
		props: route => route.params,
		component: () => import('@/pages/basic/dispatch_rule_list.vue')
	},
	//售后费用标准
	{
		path: 'fee_config',
		name: 'm_fee_config',
		props: route => route.params,
		component: () => import('@/pages/basic/fee_config_list.vue')
	},
];